import React, { Component } from 'react';
import { observer } from 'mobx-react';
import InstructionVideoUploadService from '../services/InstructionVideoUploadService';
import InstructionVideoUploadDialog from './InstructionVideoUploadDialog';

class InstructionVideoUploadDialogContainer extends Component {
  render() {
    return (
      <InstructionVideoUploadDialog
        uploadedPercentage={InstructionVideoUploadService.uploadedPercentage}
        isOpen={InstructionVideoUploadService.isOpen}
      />
    );
  }
}

export default observer(InstructionVideoUploadDialogContainer);
